import React, { useCallback, useEffect, useState } from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import ColumnTable from "../embrillTable/ColumnTable";
import { useDispatch, useSelector } from "react-redux";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { useNavigate } from "react-router-dom";
import { fetchAsyncGetClient } from "redux/clientProjectSlice";
import { AiFillDelete, AiFillEye } from "react-icons/ai";
import { fetchAsyncDeleteClient } from "redux/clientProjectSlice";
import ProjectPopover from "components/models/addProjectModal";
import { FaPlus } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ClientProject from "components/allForm/clientProject/clientProject";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import jsonData from "components/jsonData/clientProject.json"; // Adjust the path as necessary
import { genericSort } from "../embrillTable/customSort/customSort";
import { RiBankCardFill } from "react-icons/ri";
import useSearch from "hooks/useSearch";
import { fetchAsyncExportClient } from "redux/clientProjectSlice";
import ExcelJS from "exceljs";

import { BiExport } from "react-icons/bi";
import { GstTreatment } from "components/allForm/Vendors/customFieldData";
import { accountTypeOptions } from "components/allForm/PurchaseItem/selectedOptions";
import { GetCountries } from "utiils/countryStateCity";
import { GetState } from "utiils/countryStateCity";
import { GetCity } from "utiils/countryStateCity";
import moment from "moment";
const EmbrillClientProjects = () => {
  const dispatch = useDispatch();
  const [clientListData, setClientListData] = useState([]);
  const currUser = useSelector((state) => state.auth.currUser);
  const [role, setRole] = useState("");
  const { searchText } = useSelector((state) => state.searchValue);
  const navigate = useNavigate();
  const { performSearch } = useSearch();

  useEffect(() => {
    if (currUser && currUser?.auth) {
      const auth = currUser?.auth;
      const roleObj =
        auth &&
        auth?.length > 0 &&
        auth.find((item) => item?.module === "Client and Projects");
      if (roleObj) {
        setRole(roleObj?.access);
      }
    }
  }, [currUser]);

  const columnsDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Client Name",
      accessor: "clientName",
      sortType: genericSort,
    },
    {
      Header: "Pan Number",
      accessor: "panNumber",
    },
    {
      Header: "Projects",
      accessor: "projects",
    },
    {
      Header: "Bank Account",
      accessor: "bankAccount",
    },
    {
      Header: "Last Updated",
      accessor: "lastUpdated",
    },
    {
      Header: "Action",
      accessor: "action",
    },
  ];
  const [openClientModal, setOpenClientModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [clientEditData, setClientEditData] = useState(false);

  const handleOpenClientModal = () => {
    setOpenClientModal(true);
  };

  const getDropdownLabel = (option, fldName) => {
    switch (fldName) {
      case "taxType": {
        const opt = GstTreatment.find((opt) => opt.id === option);
        return opt?.label;
      }

      case "accountType": {
        const opt = accountTypeOptions.find((opt) => opt.id === option);
        return opt?.label;
      }

      default:
        return option;
    }
  };
  // const exportClientExcelDynamicColumns = async (data) => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Clients");

  //   // data = transformed data from your previous step

  //   const maxBanks = Math.max(...data.map(c => c.bankDetails?.length || 0), 0);
  //   const maxGSTs = Math.max(...data.map(c => c.gstDetails?.length || 0), 0);
  //   const maxAddresses = Math.max(...data.map(c => c.address?.length || 0), 0);

  //   const columns = [
  //     "Client ID",
  //     "Company Name",
  //     "Website URL",
  //     "Country",
  //     "Region/Time Zone",
  //     "Language",
  //     "Representative Name",
  //     "Representative Email",
  //     "Representative Phone Number",
  //     "Business Entity Type",
  //     "Publicly Listed?",
  //     "Industry Type",
  //     "Client Source",
  //     "Year of Incorporation",
  //     "Organization Size",
  //     "Business Model",
  //     "Currency",
  //     "Payment Terms",
  //     "Company Name [As per Taxation]",
  //     "Accounts Contact Name",
  //     "Accounts Email Address",
  //     "Accounts Phone Number",
  //     "Company Registration Number",
  //     "Tax Jurisdiction",
  //     "Tax Registration type",
  //   ];

  //   for (let i = 1; i <= maxBanks; i++) {
  //     columns.push(
  //       `Account Currency - ${i}`,
  //       `Account Holder Name - ${i}`,
  //       `Account Alias / Nickname - ${i}`,
  //       `Bank Name - ${i}`,
  //       `Account Number - ${i}`,
  //       `Account Type - ${i}`,
  //       `IFSC Code - ${i}`,
  //       `Branch Name - ${i}`,
  //       `SWIFT Code - ${i}`,
  //       `Opening Balance - ${i}`,
  //     );
  //   }

  //   for (let i = 1; i <= maxGSTs; i++) {
  //     columns.push(`GST/VAT/Tax ID - ${i}`, `PAN Number - ${i}`);
  //   }

  //   for (let i = 1; i <= maxAddresses; i++) {
  //     columns.push(
  //       `Address Line 1 - ${i}`,
  //       `Address Line 2 - ${i}`,
  //       `Country - ${i}`,
  //       `State - ${i}`,
  //       `Town/City - ${i}`,
  //       `Pincode - ${i}`,
  //       `Address Type - ${i}`,
  //     );
  //   }

  //   worksheet.columns = columns.map(col => ({
  //     header: col,
  //     key: col,
  //     width: 25,
  //   }));

  //   data.forEach(client => {
  //     const row = {
  //       "Company Name": client.comNam,
  //       "Representative Email": client.reEmail,
  //       "Representative Phone Number": client.reN,
  //       "Tax Registration type": client.taxRegTyp,
  //     };

  //     client.bankDetails?.forEach((bank, idx) => {
  //       const i = idx + 1;

  //       row[`Account Holder Name - ${i}`] = bank.hldNam;
  //       row[`Bank Name - ${i}`] = bank.bankNam;
  //       row[`Account Number - ${i}`] = bank.bankAccNum;
  //       row[`Account Type - ${i}`] = bank.accTyp;
  //       row[`IFSC Code - ${i}`] = bank.ifsc;
  //       row[`Branch Name - ${i}`] = bank.brchNam;
  //       row[`SWIFT Code - ${i}`] = bank.swift;
  //     });

  //     client.gstDetails?.forEach((gst, idx) => {
  //       const i = idx + 1;

  //       row[`GST/VAT/Tax ID - ${i}`] = gst.taxId;
  //       // PAN Number unavailable
  //     });

  //     client.address?.forEach((address, idx) => {
  //       const i = idx + 1;

  //       row[`Address Line 1 - ${i}`] = address.houseNo;
  //       row[`Address Line 2 - ${i}`] = address.area;
  //       row[`State - ${i}`] = address.state;
  //       row[`Town/City - ${i}`] = address.city;
  //       row[`Pincode - ${i}`] = address.pinCode;
  //       row[`Address Type - ${i}`] = address.addType;
  //     });

  //     worksheet.addRow(row);
  //   });

  //   worksheet.getRow(1).font = { bold: true };

  //   worksheet.columns.forEach(column => {
  //     column.width = Math.max(column.width || 20, column.header.length + 2);
  //   });

  //   const buffer = await workbook.xlsx.writeBuffer();

  //   downloadBufferAsExcelFile(buffer)
  // };

  const downloadClientExportGrouped = async (data) => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "Your App";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet("Clients", {
      properties: {
        defaultRowHeight: 22,
      },
      views: [
        {
          state: "frozen",
          ySplit: 1,
        },
      ],
    });

    worksheet.columns = [
      { header: "Sr. No.", key: "srNo", width: 10 },
      { header: "Company Name", key: "companyName", width: 30 },

      { header: "Representative Email", key: "repEmail", width: 28 },
      { header: "Representative Phone Number", key: "repPhone", width: 20 },

      { header: "Tax Registration Type", key: "taxType", width: 22 },

      { header: "PAN Number", key: "pan", width: 18 },

      { header: "GST/VAT/Tax ID", key: "gst", width: 22 },
      { header: "Place of Supply", key: "pos", width: 22 },

      { header: "Address Line 1", key: "addr1", width: 28 },
      { header: "Address Line 2", key: "addr2", width: 28 },
      { header: "Attention", key: "attention", width: 22 },
      { header: "Country", key: "addrCountry", width: 18 },
      { header: "State", key: "addrState", width: 18 },
      { header: "Town/City", key: "addrCity", width: 18 },
      { header: "Pincode", key: "addrPin", width: 15 },
      { header: "Address Type", key: "addrType", width: 18 },
      { header: "Phone", key: "addr_phone", width: 18 },
      { header: "Email", key: "addr_email", width: 28 },

      { header: "Account Holder Name", key: "holder", width: 24 },
      { header: "Account Number", key: "account", width: 22 },
      { header: "IFSC Code", key: "ifsc", width: 18 },
      { header: "Account Type", key: "accountType", width: 18 },
      { header: "Bank Name", key: "bank", width: 24 },
      { header: "SWIFT Code", key: "swift", width: 18 },
      { header: "Branch Name", key: "branch", width: 22 },
      { header: "City", key: "bnk_city", width: 18 },
      { header: "State", key: "bnk_state", width: 18 },

      { header: "Project", key: "project", width: 28 },
    ];

    // ---------------- Header Style ----------------

    const headerRow = worksheet.getRow(1);
    headerRow.height = 26;

    headerRow.eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: "FFFFFFFF" },
        size: 11,
      };

      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "1F4E78" },
      };

      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };

      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
      };
    });

    const mergeColumns = ["A", "B", "C", "D", "E","F"];

    // Number columns (right aligned)
    const numericColumns = ["C", "I", "P", "T"];
    
    
    let serialNo = 1;
    let currentRow = 2;

    for (const client of data) {
      const banks = client.bankDetails || [];
      const addresses = client.address || [];
      const gsts = client.gstDetails || [];
      const projects = client.projects || [];

      const country = await GetCountries();

      const span = Math.max(
        banks.length,
        addresses.length,
        gsts.length,
        projects.length,
        1,
      );

      for (let i = 0; i < span; i++) {
        const bank = banks[i] || {};
        const address = addresses[i] || {};
        const gst = gsts[i] || {};
        const project = projects[i] || {};

        const state = await GetState(address.country);
        const city = await GetCity(address.country, address.state);

        worksheet.addRow({
          srNo: i === 0 ? serialNo : "",

          companyName: i === 0 ? client.comNam : "",
          repEmail: i === 0 ? client.reEmail : "",
          repPhone: i === 0 ? client.reN : "",
          taxType:
            i === 0 ? getDropdownLabel(client.taxRegTyp, "taxType") || "" : "",

          pan: i === 0 ? client.panNo : "",

          gst: gst.taxId || "",
          pos: gst.pos || "",

          attention: address.attention || "",
          addr_phone: address.phone || "",
          addr_email: address.email || "",

          addr1: address.houseNo || "",
          addr2: address.area || "",

          addrCountry:
            country.find((c) => c.id === address.country)?.name || "",

          addrState: state.find((s) => s.id === address.state)?.name || "",

          addrCity: city.find((c) => c.id === address.city)?.name || "",

          addrPin: address.pinCode || "",
          addrType: address.addType || "",

          holder: bank.hldNam || "",
          bank: bank.bankNam || "",
          account: bank.bankAccNum || "",

          accountType: getDropdownLabel(bank.accTyp, "accountType") || "",

          ifsc: bank.ifsc || "",
          branch: bank.brchNam || "",
          swift: bank.swift || "",
          bnk_city: bank.city || "",
          bnk_state: bank.state || "",

          project: project.prj || "",
        });
      }

      if (span > 1) {
        const start = currentRow;
        const end = currentRow + span - 1;

        mergeColumns.forEach((col) => {
          worksheet.mergeCells(`${col}${start}:${col}${end}`);

          worksheet.getCell(`${col}${start}`).alignment = {
            vertical: "middle",
            horizontal: "left",
            wrapText: true,
          };
        });
      }

      currentRow += span;

      worksheet.addRow({});

      worksheet.mergeCells(`A${currentRow}:AB${currentRow}`);

      currentRow++; serialNo++;
    }

    // ---------------- Data Styling ----------------

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) return;

      row.eachCell((cell, colNumber) => {
        const columnLetter = worksheet.getColumn(colNumber).letter;

        // Alignment
        cell.alignment = {
          vertical: "middle",
          horizontal: numericColumns.includes(columnLetter) ? "right" : "left",
          wrapText: true,
        };

        // Treat all string values as text
        if (typeof cell.value === "string") {
          cell.numFmt = "@";
        }

        cell.font = {
          size: 10,
        };
      });
    });

   
    // Download
    const buffer = await workbook.xlsx.writeBuffer();
    downloadBufferAsExcelFile(buffer);
  };

  function downloadBufferAsExcelFile(buffer) {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `clients_${moment().format("DD-MMM-YYYY")}.xlsx`;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  async function handleExport() {
    const data = await fetchAsyncExportClient();
    if (data?.data) {
      // exportClientExcelDynamicColumns(data?.data);
      downloadClientExportGrouped(data?.data);
    }
  }


  const handleCloseClientModal = () => {
    setOpenClientModal(false);
    setOpenEditModal(false);
    setClientEditData(null);
    handlerRefreshData();
  };
  const handlerRefreshData = useCallback(() => {
    performSearch(searchText);
  }, [searchText, performSearch]);

  const [loading, setLoading] = useState(false);

  const clientList = useSelector((state) => state.clientData);

  const deleteClientProject = (data) => {
    dispatch(fetchAsyncDeleteClient(data._id)).then(() => {
      handlerRefreshData();
    });
  };

  useEffect(() => {
    if (clientList && clientList.length > 0) {
      const tableData = clientList.map((data, index) => {
        return {
          _id: data._id,
          no: index + 1,

          clientName: (
            <span style={{ cursor: "pointer", color: "blue" }}>
              {data?.clName}
            </span>
          ),
          panNumber: data?.pnNo,

          lastUpdated: dateTimeFormat(data.upAt),
          projects: (
            <>
              <ProjectPopover
                clientId={data._id}
                projects={data.prjs}
                refreshData={() => dispatch(fetchAsyncGetClient())}
                role={role}
              />
            </>
          ),
          bankAccount: (
            <div class="position-relative mx-4">
              <RiBankCardFill size={25} />
              <span className="position-absolute top-0 start-100 translate-middle badge  bg-primary text-white">
                {data?.bnkDtl && data?.bnkDtl?.length
                  ? data?.bnkDtl?.length
                  : 0}
              </span>
            </div>
          ),
          action: (
            <div className="d-flex">
              {role === "Admin" ? (
                <>
                  <MdModeEdit
                    className="me-2"
                    color="blue"
                    size={16}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      handleEditClick(e, data._id);
                    }}
                  />
                  <AiFillEye
                    className="me-2"
                    color="#000D55"
                    size={16}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      handleRowClick(e, data?._id);
                    }}
                  />

                  <AiFillDelete
                    style={{ cursor: "pointer", marginLeft: "10px" }}
                    size={16}
                    onClick={(e) => {
                      const confirmationMessage = jsonData.confirm.clientDelete;
                      const title = confirmationMessage.replace(
                        "{clientName}",
                        data?.clName,
                      );
                      ConfirmationDialog({
                        title: title,
                        text: jsonData.text.undone,
                        icon: "warning",
                        confirmButtonText: "delete",
                        cancelButtonText: "Cancel",
                        onConfirm: () => {
                          deleteClientProject(data);
                        },
                      });
                    }}
                  />
                </>
              ) : (
                "No Access"
              )}
            </div>
          ),
        };
      });
      setClientListData(tableData);
    } else {
      setClientListData([]);
    }
  }, [clientList]);

  const handleRowClick = (e, _id) => {
    e.stopPropagation();
    navigate(`/client-project/${_id}`);
  };
  const handleEditClick = (e, _id) => {
    e.stopPropagation();
    const data = clientList.filter((item) => item?._id === _id);
    setOpenEditModal(true);
    setClientEditData(data[0]);
    handleOpenClientModal();
  };

  useEffect(() => {
    setLoading(true);
    dispatch(fetchAsyncGetClient())
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);

  const textColor = useColorModeValue("secondaryGray.900", "white");

  if (loading) {
    return <SpinnerLoader />;
  }
  return (
    <>
      <Box display="flex" className="mx-0" justifyContent="space-between">
        <Box display="flex">
          <Text
            color={textColor}
            fontSize="22px"
            fontWeight="700"
            lineHeight="100%"
            mt={5}
            mx={2}
          >
            Client And Projects
          </Text>
        </Box>
        <Box display="flex" mt={2} className="add-new-btn gap-2">
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleExport}
          >
            <BiExport size={12} className="new-plus-icon text-white fs-4" />{" "}
            Export
          </Box>
          <Box
            display="flex"
            alignItems="center"
            className="new-btn"
            onClick={handleOpenClientModal}
          >
            <FaPlus size={12} className="new-plus-icon" /> New
          </Box>
        </Box>
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <ColumnTable
          columnsData={columnsDataColumns}
          tableData={clientListData}
          type={"Client And Projects"}
          role={role}
          expenseType="client-project"
          openInfoModal={handleRowClick}
        />
      </Box>
      {openClientModal && (
        <ClientProject
          openModal={openClientModal}
          closeModal={handleCloseClientModal}
          isEditForm={openEditModal}
          editItem={clientEditData}
          role={role}
          refreshEditData={handlerRefreshData}
        />
      )}
    </>
  );
};

export default EmbrillClientProjects;
